import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';

const constructTaskObject = (task, hideParams = []) => {
  const {
    name: taskTitle,
    description,
    technician,
    techGroup,
    status,
    estimatedTime,
    scheduledStartDate,
    dueDate,
    inlineImages = [],
    taskOrder,
    priority
  } = task;
  const techInput = technician && {
    userId: technician.userId,
    email: technician.email,
    firstName: technician.firstName,
    lastName: technician.lastName
  };
  const groupInput = techGroup && {
    groupId: techGroup.groupId,
    name: techGroup.name
  };
  const taskObj = {
    title: taskTitle,
    description,
    status,
    estimatedTime,
    scheduledStartDate,
    dueDate,
    technician: techInput,
    techGroup: groupInput,
    inlineImages: inlineImages,
    taskOrder,
    priority
  };
  // Remove unwanted params
  hideParams.forEach((param) => {
    delete taskObj[param];
  });
  return taskObj;
};

const getTimeDifference = (end) => {
  if (!end) {
    return 1;
  }
  const endDate = dayjs(end)
    .toDate()
    .getTime();
  const currentDate = new Date().getTime();
  const timeDifference = (endDate - currentDate) / (1000 * 3600 * 24);
  return timeDifference;
};

const renderTime = (time) => {
  if (time) {
    const actualTime = time;
    const hrs = `${Math.floor(actualTime / 60)}`;
    const mins = `${actualTime % 60}`;
    if (actualTime % 60) {
      return `${hrs}h ${mins}m`;
    }
    return `${hrs}h`;
  }
  return null;
};

const isUnauthorizedUserPresent = (memberList, taskList) => {
  let isInvalid = false;
  taskList.some(function(item, index) {
    if (
      item?.technician?.userId &&
      !memberList.includes(item.technician.userId)
    ) {
      isInvalid = true;
      return true;
    }
  });
  return isInvalid;
};

const filterAttrs = (obj) => {
  if (obj) {
    const { name, ...rest } = obj;
    return rest;
  }
  return obj;
};

const excludeMembers = (memberList, taskList) => {
  return taskList.map((task) => {
    const updatedTask = cloneDeep(task);
    if (
      updatedTask?.technician?.userId &&
      !memberList.includes(updatedTask.technician.userId)
    ) {
      updatedTask.technician = null;
    }
    return updatedTask;
  });
};

export {
  constructTaskObject,
  getTimeDifference,
  renderTime,
  isUnauthorizedUserPresent,
  filterAttrs,
  excludeMembers
};
